import {Component, OnInit} from '@angular/core';
import {differenceInDays, endOfDay} from 'date-fns';
import {JobsDataService} from '../../../../modules/jobs/jobs-data.service';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-similar-jobs',
    templateUrl: './similar-jobs.component.html',
    styleUrls: ['./similar-jobs.component.scss']
})
export class SimilarJobsComponent implements OnInit {

    constructor(private jobService: JobsDataService, private route: ActivatedRoute) {
    }

    postedDaysAgo: number;
    postedOn = new Date(2021, 0, 20);


    similarJobData: any = [];
    jobId: string;

    ngOnInit(): void {
        // get difference between
        this.postedDaysAgo = differenceInDays(endOfDay(new Date()), this.postedOn);

        this.route.params.subscribe((jobIdUrl: any) => {
            this.jobId = jobIdUrl.id
            this.jobService.getSimilarJob(this.jobId).subscribe((similarJobData: any) => {
                this.similarJobData = similarJobData;
            })
        })


    }
}
